import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import Config from '../utils/config.service';
import HttpHelper from '../utils/http-helper.service';

@Injectable({ providedIn: 'root' })
export default class ScreeningEscalationRestService {
	private httpClient: HttpClient = inject(HttpClient);
	private config: Config = inject(Config);
	private httpHelper: HttpHelper = inject(HttpHelper);

	private readonly tokenStorageKey: string = 'siffi.pilot.token';
	private readonly orgStorageKey: string = 'siffi.pilot.org';
	private readonly localeStorageKey: string = 'siffi.pilot.locale';

	getAvailability() {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/api/v1/screening/availability', { observe: 'response' });
		return this.httpHelper.executeHttp(httpPromise, undefined, undefined);
	}

	claimSession(token, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/sessions/claim', { token: token }, {
			withCredentials: true,
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	createSession(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/sessions', data, {
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	exchangeFollowupSession(ott, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/followup/' + ott + '/session', {}, {
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitConsents(token, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/sessions/' + token + '/consents', data, {
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitLinkageCode(token, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/sessions/' + token + '/linkage-code', data, {
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitTier1(token, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/sessions/' + token + '/screening/tier1', data, {
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	submitTier2(token, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/sessions/' + token + '/screening/tier2', data, {
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	getResult(token, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.get(this.config.getRestUrl() + 'publicrest/api/v1/sessions/' + token + '/result', {
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	requestRegistration(data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/registrations', data, {
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	completeRegistration(verificationToken, data?, successCallback?, errorCallback?) {
		var httpPromise: any = this.httpClient.post(this.config.getRestUrl() + 'publicrest/api/v1/registrations/' + verificationToken + '/complete', data, {
			withCredentials: true,
			observe: 'response'
		});
		return this.httpHelper.executeHttp(httpPromise, successCallback, errorCallback);
	}

	savePilotContext(token, org?, locale?) {
		var previousOrg: any = this.getPilotOrg();
		var orgChanged: boolean = !!(org && previousOrg && previousOrg !== org);
		if (orgChanged) {
			this.clearPilotToken();
		}
		if (org) {
			window.localStorage.setItem(this.orgStorageKey, org);
		}
		if (token) {
			window.sessionStorage.setItem(this.tokenStorageKey, token);
		}
		if (locale) {
			window.localStorage.setItem(this.localeStorageKey, locale);
		}
	}

	getPilotToken() {
		var token: string = window.sessionStorage.getItem(this.tokenStorageKey);
		if (token) {
			return token;
		}
		token = window.localStorage.getItem(this.tokenStorageKey);
		if (token) {
			window.sessionStorage.setItem(this.tokenStorageKey, token);
			window.localStorage.removeItem(this.tokenStorageKey);
		}
		return token;
	}

	getPilotOrg() {
		return window.localStorage.getItem(this.orgStorageKey);
	}

	getPilotLocale() {
		return window.localStorage.getItem(this.localeStorageKey);
	}

	clearPilotToken() {
		window.sessionStorage.removeItem(this.tokenStorageKey);
		window.localStorage.removeItem(this.tokenStorageKey);
	}

	clearPilotContext() {
		this.clearPilotToken();
		window.localStorage.removeItem(this.orgStorageKey);
		window.localStorage.removeItem(this.localeStorageKey);
	}
}
